import { generateRecordRoute } from '~/features/record/lib/generateRecordRoute';

export const NavRoutes = <const>{
  Artwork: '/artwork',
  Home: '/home',
  Events: '/events',
  Record: '/record',
  Stamps: '/stamps',
  Measure: '/measure',
  FAQ: '/faq',
  Entry: '/',
  Register: '/register',
  Cloakroom: generateRecordRoute({ tabKey: 'shoes' }),
  Withdraw: '/withdraw',
  Withdrawn: '/withdrawn',
  Scan: '/mfid',
  ScanResult: '/result',
  Predict: '/predict',
  Gallery: '/gallery',
};

export type NavRoutes = (typeof NavRoutes)[keyof typeof NavRoutes];
